import * as tslib_1 from "tslib";
import { ConnectedAccountsOption, initConnectedAccountsFull } from 'owa-connected-accounts-option';
import PopImapOption from 'owa-pop-imap-option/lib/PopImapOption';
import { trace } from 'owa-trace';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var accountsSubCategory = {
    key: 'accounts',
    titleStringKey: 'optionSubcategory_accounts',
    options: [ConnectedAccountsOption, PopImapOption],
    onSelected: function () {
        return loadAccountsConfiguration();
    },
};
function loadAccountsConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!isControlFeatureEnabled('auth-connectedAccounts')) return [3 /*break*/, 2];
                    return [4 /*yield*/, initConnectedAccountsFull()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, true];
                case 3:
                    e_1 = _a.sent();
                    trace.warn(e_1.message);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export default accountsSubCategory;
//# sourceMappingURL=accountsSubCategory.js.map